import { useMutation } from "@tanstack/react-query";
import type { ReactElement } from "react";
import type { SmartForecastResult } from "@cx/contracts";
import { formatBRL, formatDateBR } from "@cx/domain";
import { useSession } from "../../session";
import { errorMessage } from "../../errors";

/**
 * Previsão inteligente (T3.7, RF-BI-06) no Dashboard Mensal: padrão do dia da semana × ritmo do mês (cálculo
 * determinístico) e a explicação em português (modelo, ou texto padrão sem ele).
 */
export function SmartForecast(): ReactElement {
  const { api } = useSession();
  const m = useMutation({
    mutationFn: () => api<SmartForecastResult>("/ai/agents/forecast", { method: "POST" }),
  });
  const f = m.data?.forecast;
  return (
    <div className="w-100">
      {!m.data && (
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          disabled={m.isPending}
          onClick={() => m.mutate()}
        >
          {m.isPending ? "Calculando…" : "Previsão inteligente"}
        </button>
      )}
      {m.error && <div className="text-danger small">{errorMessage(m.error)}</div>}
      {m.data && (
        <div className="small mt-1" data-testid="smart-forecast">
          {f && (
            <div className="fw-semibold">
              Previsão inteligente em {formatDateBR(f.monthEnd)}: {formatBRL(f.projectedCents)} (entre{" "}
              {formatBRL(f.lowCents)} e {formatBRL(f.highCents)})
            </div>
          )}
          <div>{m.data.explanation}</div>
        </div>
      )}
    </div>
  );
}
